module.exports = "pegasus_template/assets/preview-8.png";